export const collectionModel = {
   'name': {
      'title': "Name",
      'display': true
   },
   'ssh_username': {
      'title': "SSH Username",
      'display': false
   },
   'ssh_password': {
      'title': "SSH Password",
      'display': false
   }
};